export default {
      id: "eye-usage",
      viewBox: "0 0 21 17",
      url: __webpack_public_path__ + "sprite-46b249.svg#eye-usage",
      toString: function () {
        return this.url;
      }
    }